import { PRESENCE_STATES } from 'lib/common/constants/presenceStates';

import getMappedConnectState from './getMappedConnectState';

export function getAgentPresence(connectState: string | null) {
  if (!connectState) {
    return PRESENCE_STATES.OFFLINE;
  }

  return getMappedConnectState(connectState as PRESENCE_STATES);
}
